import { HStack, Tab, TabList, Tabs } from "@chakra-ui/react";
import { forwardRef, useCallback } from "react";

/**
 * @template {any} T
 * @typedef {object} TabInputItem
 * @property {string} label
 * @property {T} value
 */

export const TabInput = forwardRef(
  /**
   * @template {any} [T=any]
   * @typedef {Object} Props
   * @property {TabInputItem<T>[]} items
   */
  /**
   * @param {Props & import("@raiden/library/components/ReactHookForm/FormController").FieldProps<any[]>} props
   */
  function TabInput({ items, name, value, onChange }, ref) {
    const index = items.findIndex(
      (item) => JSON.stringify(item.value) === JSON.stringify(value),
    );

    const handleClick = useCallback(
      /**
       * @param {object} params
       * @param {TabInputItem<any>} params.item
       */
      ({ item }) => {
        if (JSON.stringify(value) !== JSON.stringify(item.value)) {
          onChange({ target: { name, value: item.value } });
        } else {
          onChange({ target: { name, value: [] } });
        }
      },
      [name, onChange, value],
    );

    return (
      <Tabs index={index}>
        <TabList borderBottomWidth={0} overflowX="auto" pb="2px">
          <HStack spacing="24px">
            {items.map((item, index) => (
              <Tab
                ref={index === 0 ? ref : undefined}
                onClick={(e) => {
                  // focus selft
                  e.currentTarget.scrollIntoView({
                    block: "center",
                    behavior: "smooth",
                  });
                  handleClick({ item });
                }}
                whiteSpace="nowrap"
                px="0"
                key={item.value}>
                {item.label}
              </Tab>
            ))}
          </HStack>
        </TabList>
      </Tabs>
    );
  },
);
